/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
  * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
// lui utilise la syntaxe d'export es6, c'est l'export par défaut qu'on veut
// const BinaryParser = require('../../outilsExternes/binaryParser/binary-parser').default
const BinaryParser = require('../../outilsExternes/binaryParser/binary-parser-Daniel').default
// import Utf8Utils from '../outilsExternes/Utf8Utils/Utf8Utils'
// import classe from '../classes/classe'
const factory = require('../classes/objetFactory')
// const utf8 = require('utf8')
const utf8 = require('../../outilsExternes/Utf8Utils/Utf8Utils')

module.exports = DataInputStream

/**
 * Classe servant à charger une figure depuis un flux binaire base 64
 * contenu dans un tableau de bytes
 * @constructor
 * @param {Array} ba
 * @returns {undefined}
 */
function DataInputStream (ba) {
  this.ba = ba;
  this.listeNomsClasse = [];
  // Spécial JavaScript : pour pouvoir enregistrer la figure dans le flux, il faut aussi connaître le préfixe
  // du nom de classe qui est utilisé en Java
  // this.listePrefixes = []; // Abandonné version 5.2 car le prefix est toujours objets !
  this.listeNumerosVersion = [];
  this.bp = new BinaryParser(true, true);
  this.indiceEnCours = 0;
}
DataInputStream.inputStreamError = "Erreur de flux";
// DataInputStream.numeroVersionActif = 17; // Changé version 5.4
DataInputStream.numeroVersionActif = 18; // Changé version 6.0

/**
 * Saute nbBytes dans la lecture du tableau de bytes
 * @param {Integer} nbBytes
 * @returns {undefined}
 */
DataInputStream.prototype.skip = function(nbBytes) {
  this.indiceEnCours += nbBytes;
};
/**
 * Lit un boolean depuis le tableau de bytes
 * @returns {Boolean}
 */
DataInputStream.prototype.readBoolean = function() {
  if (this.indiceEnCours >= this.ba.length) throw new Error(DataInputStream.inputStreamError);
  return (this.ba[this.indiceEnCours++] === 1);
};
/**
 * Lit un byte depuis le tableau de bytes
 * @returns {Array}
 */
DataInputStream.prototype.readByte = function() {
  if (this.indiceEnCours >= this.ba.length) throw new Error(DataInputStream.inputStreamError);
  return (this.ba[this.indiceEnCours++]);
};
/**
 * Lit un integer sur 4 octets depuis le tableau de bytes
 * @returns {Integer}
 */
DataInputStream.prototype.readInt = function() {
  var b1 = this.readByte();
  var b2 = this.readByte();
  var b3 = this.readByte();
  var b4 = this.readByte();
  return(((b1 << 24) & 0xFF000000) |((b2 << 16) & 0x00FF0000) | ((b3 << 8) & 0x0000FF00) | b4);
};
/**
 * Lit un entier sur deux octets depuis le tableau de bytes.
 * @returns {Integer}
 */
DataInputStream.prototype.readShortInt = function() {
  var b1 = this.readByte();
  var b2 = this.readByte();
  return(((b1 << 8) & 0x0000FF00) | b2);
};
/**
 * Lit un double depuis le tableau de bytes
 * @returns {Double}
 */
DataInputStream.prototype.readDouble = function() {
  var ch = String.fromCharCode(this.readByte(), this.readByte(), this.readByte(), this.readByte(),
      this.readByte(), this.readByte(), this.readByte(), this.readByte());
  return this.bp.toDouble(ch);
};
/**
 * Lit un float depuis e tableau de bytes.
 * @returns {Float}
 */
DataInputStream.prototype.readFloat = function() {
  var ch = String.fromCharCode(this.readByte(), this.readByte(), this.readByte(), this.readByte());
  return this.bp.toFloat(ch);
};
/**
 * Lit une chaîne UTF depuis le tableau de bytes
 * @returns {String}
 */
DataInputStream.prototype.readUTF = function() {
  var len = this.readShortInt(this.ba);
  // var ret = Utf8Utils.decode(this.ba.slice(this.indiceEnCours, this.indiceEnCours + len));
  // @FIXME, on recupère un tableau, utf8.decode veut une string
  // Marche quand même !
  var ret = utf8.decode(this.ba.slice(this.indiceEnCours, this.indiceEnCours + len));
  this.indiceEnCours += len;
  return ret;
};
/**
 * Lit un objet depuis le tableau de bytes.
 * @param {type} liste
 * @returns {mtg32|DataInputStream.prototype.readObject.ob}
 */
DataInputStream.prototype.readObject = function(liste) {
  var ob,nomClasse,numVer,s,ind;
  s = this.readInt();
  if (s === -1) {
    numVer = this.readInt();
    nomClasse = this.readUTF();
    ind = nomClasse.indexOf(".", 0);
    if (ind !== -1) {
      nomClasse = nomClasse.substring(ind+1);
    }
    this.listeNomsClasse.push(nomClasse);
    this.listeNumerosVersion.push(numVer);
  }
  else {
    nomClasse = this.listeNomsClasse[s];
    numVer = this.listeNumerosVersion[s];
  }
  /* Modifié new
  if (!mtg32[nomClasse]) throw new Error("Erreur chargement objet");
  ob = new mtg32[nomClasse](liste);
  */
  // ob = classe(nomClasse, liste);
  ob = factory(nomClasse, liste);
  if (ob === null) throw new Error("Erreur chargement objet");
  ob.nVersion = numVer;
  ob.read(this, liste);
  return ob;
};
/**
 * Lit une image depuis le tableau de bytes.
 * L'image est renvoyée sous forme d'un tableau d'entiers
 * @returns {Array}
 */
DataInputStream.prototype.readBufferedImage = function(){
  var size = this.readInt();
  var bar = [];
  for (var i = 0; i < size; i++) bar[i] = this.readByte();
  // var res =  kernel.base64Encode(bar, true); // Encodage standard
  return bar;
};
